import { Mapper } from "../../../../base/utils/mapper";
import { ElectrocardiogramRhythmModel } from "../../../../domain/models/consult/electrocardiogram-rhythm.model";
import { ElectrocardiogramRhythmEntity } from "../entities/electrocardiogram-rhythm.entity";



export class ElectrocardiogramRhythmRepositoryMapper extends Mapper<ElectrocardiogramRhythmEntity, ElectrocardiogramRhythmModel> {
    mapFrom(param: ElectrocardiogramRhythmEntity): ElectrocardiogramRhythmModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            error:param.error
        };
    }
    mapTo(param: ElectrocardiogramRhythmModel): ElectrocardiogramRhythmEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            error:param.error
        }
    }
}